var map = {
	"./buyin.png": 903,
	"./coelho.png": 274,
	"./counterspell.png": 82,
	"./fichas.png": 218,
	"./lugar.png": 383,
	"./mesa.png": 114,
	"./ponto.png": 978
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 323;